import { ChakraProvider } from "@chakra-ui/react";
import NavigationMenu from "./components/NavigationMenu";
import Brands from "./components/Brands";

import Hero from "./components/Hero";
import Services from "./components/Services";
import Cases from "./components/Cases";

// TODO: Implement these in the future
// import Alert from "./components/Alert";
// import ContactMeSection from "./components/ContactMeSection";
import Footer from "./components/Footer";
import { AlertProvider } from "./context/alertContext";
import theme from "./theme";
import Fonts from "./theme/fonts";

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Fonts />
      <AlertProvider>
        <main>
          {/* <Alert /> */}
          <NavigationMenu />
          <Hero />
          {/* <Services />
          <Cases /> */}
          {/* <Brands /> */}
          {/* TODO: Style this correctly once we have a brief  */}
          {/* <ContactMeSection /> */}
          <Footer />
        </main>
      </AlertProvider>
    </ChakraProvider>
  );
}

export default App;
